// extracted by mini-css-extract-plugin
export var link = "rich-text-link-module--link--55cd8";